/* global $ */

$('.js-print').on('click', (e) => {
  e.preventDefault();
  window.print();
});
